import { installCollectionPaging } from './utils/collectionPaging';
import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import './design-system/css-variables.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { ThemeProvider } from './design-system';

installCollectionPaging();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();
serviceWorkerRegistration.register();
serviceWorkerRegistration.sendMessageToServiceWorker({
  type: 'SET_OFFLINE_TILE_CACHING',
  enabled: false,
});
